import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Al_Nasr_Stadium.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Al Nasr Stadium</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A sports stadium in Dubai serving as the home ground of Al Nasr FC — one of the UAE's most decorated and supported
                  football clubs. The stadium underwent significant MEP infrastructure upgrades including new chiller plant room works.</p>
              <p>MAIN CONTRACTOR : Binladin</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : CHW plant room works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one